import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { Pets } from '@mui/icons-material';

export default function ReceptionPatients() {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Clienți și pacienți</Typography>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Pets sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary">CRM receptie</Typography>
      </Paper>
    </Box>
  );
}
